
const UserOffline = () => {
    return (
      <div className="w-fit mx-auto shadow rounded-md p-4 text-slate-800">
          <h4 className="text-base sm:text-lg font-semibold text-center my-2">No, internet connection!</h4>
          <div className="bg-cyan-100 rounded-md p-2 text-sm sm:text-base">
            <h4 className="font-semibold">If you encounter problems:</h4>
            <ul className="list-disc list-inside">
              <li>Try restarting wireless connection on this device.</li>
              <li>Move closer to your wireless access point.</li>
              <li>
                If nothing works, write us a mail at{" "}
                <a
                    href="mailto:support@kitchentodoor.in?"
                    className="font-semibold"
                  >
                    support@kitchentodoor.in
                </a>
              </li>
            </ul>
          </div>
      </div>
    );
}

export default UserOffline;